import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

export const LEVELS = ['warm', 'known', 'cold', 'inferred', 'unknown'];

const VIEWBOX_SIZE = 16;

const BARS = [
  { x: 1.5, y: 3, width: 3, height: 10, rx: 1.5 },
  { x: 6.5, y: 3, width: 3, height: 10, rx: 1.5 },
  { x: 11.5, y: 3, width: 3, height: 10, rx: 1.5 },
];

// activeBars + the token used to paint them. inferred/unknown light no bars
// (the badge label disambiguates the two).
const LEVEL_CONFIG = {
  warm: { activeBars: 3, activeColor: ['green', 600] },
  known: { activeBars: 2, activeColor: ['orange', 600] },
  cold: { activeBars: 1, activeColor: ['blue', 600] },
  inferred: { activeBars: 0 },
  unknown: { activeBars: 0 },
};

const Svg = styled.svg`
  display: block;
  flex-shrink: 0;
`;

const RelationshipStrengthIndicator = ({ level, size, className, title }) => {
  const theme = useTheme();
  const effectiveLevel = LEVEL_CONFIG[level] ? level : 'unknown';
  const { activeBars, activeColor } = LEVEL_CONFIG[effectiveLevel];
  const inactiveColor = theme.colors.neutral[100];
  const fillActive = activeColor ? theme.colors[activeColor[0]][activeColor[1]] : inactiveColor;

  return (
    <Svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      role="img"
      aria-label={title || `${effectiveLevel} relationship strength`}
      data-level={effectiveLevel}
    >
      {BARS.map((bar, index) => (
        <rect key={bar.x} {...bar} fill={index < activeBars ? fillActive : inactiveColor} />
      ))}
    </Svg>
  );
};

RelationshipStrengthIndicator.propTypes = {
  level: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string,
};

RelationshipStrengthIndicator.defaultProps = {
  size: 16,
  className: undefined,
  title: undefined,
};

export default RelationshipStrengthIndicator;
